module.exports = __webpack_public_path__ + "img/yzh7.299770e3.jpg";